// Temporary test file to debug Supabase connection
import { supabase } from './supabase.config';

export async function testSupabaseConnection() {
  console.log('Testing Supabase connection...');
  
  try {
    // Test 1: Check if client is initialized
    console.log('✓ Supabase client initialized');
    
    // Test 2: Try to query a table (ministers)
    const { data, error } = await supabase
      .from('ministers')
      .select('id')
      .limit(1);
    
    if (error) {
      console.error('❌ Error querying ministers table:', error);
      return { success: false, error };
    }
    
    console.log('✓ Successfully connected to Supabase!');
    console.log('✓ Ministers table accessible');
    return { success: true, data };
    
  } catch (err) {
    console.error('❌ Unexpected error:', err);
    return { success: false, error: err };
  }
}

// Auto-run test when imported
testSupabaseConnection();
